<template>
    <toolbar-option>
        <template slot="primary">
            <toggle
                :value="checked"
                :messages="messages"
                @input="onInput"
            />
        </template>
    </toolbar-option>
</template>

<script>
import baseOption from '@/options/mixins/base-option';

export default {
    name: 'disabled',
    mixins: [baseOption],

    data() {
        return {
            checked: false,
            displayName: 'Disabled',

            messages: {
                checked: 'Yes',
                unchecked: 'No',
            },
        };
    },

    methods: {
        onInput(isChecked) {
            this.selectedElements.forEach((selectedElement) => {
                if (isChecked) {
                    selectedElement.setElementData('isDisabled', String(isChecked));
                } else {
                    selectedElement.removeElementData('isDisabled');
                }
            });

            this.checked = isChecked;
            this.onOptionChange(isChecked);
        },

        onSelectedElement() {
            const isChecked = this.selectedElements.every((selectedElement) => {
                return selectedElement.hasElementData('isDisabled');
            });

            this.checked = isChecked;
        },
    },
};
</script>
